import React, { useEffect, useState } from 'react';
import './IndustrySelector.css';
import { normalizeSupportedTimezone, SUPPORTED_TIMEZONES } from '../../utils/timezones';


function TimezoneSelector({ organization, onChange }) {
  const [timezone, setTimezone] = useState('');

  useEffect(() => {
    setTimezone(normalizeSupportedTimezone(organization?.timezone));
  }, [organization?.timezone]);

  function handleChange(event) {
    setTimezone(event.target.value);
    onChange(event.target.value);
  }

  return (
    <div>
      <div className="customize-ai-section" style={{ width: 300 }}>
        <span>Timezone</span>
        <select data-say-id="knowledge-base-timezone" className="industry-selector knowledge-timezone-selector" value={timezone} onChange={handleChange}>
          <option value="">Choose a timezone</option>
          {SUPPORTED_TIMEZONES.map(option => (
            <option key={option.value} value={option.value}>{option.label}</option>
          ))}
        </select>
      </div>
    </div>
  );
}


export default TimezoneSelector;
